/**
 * Tablet session — branch + table identity that the API needs to
 * place an order. In production this is bootstrapped from the QR
 * scan that the host sets on the iPad. For local dev / Phase-3
 * demo we read it from Vite env vars and fall back to the seed
 * branch + first seeded table.
 */

const SEED_BRANCH_ID = '11111111-1111-1111-1111-111111111111';
const SEED_TABLE_ID  = '44444444-0001-4444-4444-444444444444';

export interface TabletSession {
  branchId: string;
  tableId: string;
  customerId: string | null;
}

export function useTabletSession(): TabletSession {
  const env = import.meta.env;
  return {
    branchId:   (env.VITE_BRANCH_ID    ?? SEED_BRANCH_ID).trim(),
    tableId:    (env.VITE_TABLE_ID     ?? SEED_TABLE_ID).trim(),
    customerId: (env.VITE_CUSTOMER_ID ?? '').trim() || null,
  };
}
